import React from "react";
import { Typography as MuiTypography } from "@mui/material";
import styled from "@emotion/styled";
import Chart from "react-apexcharts";
import "../styles/styles.css";
interface AnalyticsProps {
  options: any;
  series: any;
}

const Typography = styled(MuiTypography)`
  color: var(--light-text-secondary, rgba(0, 0, 0, 0.6));
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  justify-content: center;
  margin-top: 50px;
`;
const Analytics: React.FC<AnalyticsProps> = ({ options = {}, series = [] }) => {
  const checkAllElementsAreLessThanOrEqualToZero = (data: any) => {
    const hasGreaterThanZero = data?.some((element: number) => element > 0);
    return hasGreaterThanZero;
  };

  return (
    <>
      {checkAllElementsAreLessThanOrEqualToZero(series[0]?.data) ? (
        <Chart options={options} series={series} type="bar" height={320} />
      ) : (
        <Typography>{"Waiting for the first transaction."}</Typography>
      )}
    </>
  );
};

export default Analytics;
